import { client } from '@frontend/features/common/services';

import {
  AgencyKnowledgeDto,
  CreateAgencyKnowledgePayload,
  UpdateAgencyKnowledgePayload,
} from './types';

// Scopeado a la agencia SELECCIONADA (la de la ruta /dashboard/agencies/:id),
// no a CONFIG.AGENCY_ID (que es estático de build). Consistente con el resto de
// las configuraciones de agencia.
const base = (agencyId: number) => `agencies/${agencyId}/agency-knowledge`;

export const agencyKnowledgeApi = {
  list: (agencyId: number) =>
    client.get<AgencyKnowledgeDto[]>(base(agencyId)).then((r) => r.data),

  tags: (agencyId: number) =>
    client.get<string[]>(`${base(agencyId)}/tags`).then((r) => r.data),

  create: (agencyId: number, payload: CreateAgencyKnowledgePayload) =>
    client
      .post<AgencyKnowledgeDto>(base(agencyId), payload)
      .then((r) => r.data),

  update: (
    agencyId: number,
    id: string,
    payload: UpdateAgencyKnowledgePayload,
  ) =>
    client
      .patch<AgencyKnowledgeDto>(`${base(agencyId)}/${id}`, payload)
      .then((r) => r.data),

  remove: (agencyId: number, id: string) =>
    client.delete(`${base(agencyId)}/${id}`),
};
